export default "__VITE_ASSET__CUfsJjr5__"